module.exports = __webpack_public_path__ + "static/img/order-pc-2.56142804.png";